import styled from 'styled-components';
import ResetSolid from '@simplywallst/ui-core/icons/ResetSolid';

export type ColorTheme = 'light' | 'dark';

interface Theme {
  color?: ColorTheme;
}

export const SearchSpinner = styled('div')`
  width: ${({ theme }) => theme.x2spacePx}px;
`;

export const ResetIcon = styled(ResetSolid)<Theme>`
  opacity: 0.5;
  cursor: pointer;
  > path {
    fill: ${({ theme, color }) =>
      color === 'dark' ? theme.color.white : theme.color.charcoalRGBA(0.7)};
  }
`;
